<template>
  <v-container class="mx-2">
    <v-row>
      <v-col cols="12">
        <v-breadcrumbs
          class="pl-0 pt-0"
          :items="breadcrumbs"
        ></v-breadcrumbs>
        <h1 class="mb-2">{{ $route.meta.title }}</h1>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
        >
          <v-row class="mt-4">
            <v-col cols="12" sm="6">
              <v-text-field
                label="название"
                outlined
                dense
                hide-details
                flat
                v-model=formDoorphone.name
                :rules="[
                  () => !!formDoorphone.name || 'Обязательное поле',
                ]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                label="адрес"
                outlined
                dense
                hide-details
                flat
                v-model=formDoorphone.address
                :rules="[
                  () => !!formDoorphone.address || 'Обязательное поле',
                ]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                label="контакты"
                outlined
                dense
                hide-details
                flat
                v-model=formDoorphone.contacts
                :rules="[
                  () => !!formDoorphone.contacts || 'Обязательное поле',
                ]"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-autocomplete
                label="Компания-собственник"
                :items="managementsGroup"
                v-model='formDoorphone.groupId'
                :rules="[
                  () => !!formDoorphone.groupId || 'Обязательное поле',
                ]"
                item-text="name"
                item-value="id"
                type="string"
                outlined
                dense
                flat
                clearable
              />
            </v-col>
          </v-row>
          <v-card-actions class="pl-0">
            <div class="my-2">
              <v-btn
                large
                color="success"
                class="text-none"
                @click.prevent="save"
                :disabled="!valid"
              >
                Сохранить
              </v-btn>
              <v-btn
                large
                class="ma-2 text-none"
                outlined
                dense
                hide-details color="error"
                @click.prevent="returnManagement()"
              >
                Отменить
              </v-btn>
            </div>
          </v-card-actions>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  props: ['id'],
  data () {
    return {
      valid: true,
      formDoorphone: {
        name: '',
        address: '',
        contacts: '',
        groupId: '',
      },
      breadcrumbs: [
        {
          text: 'Управляющие компании',
          disabled: false,
          href: '/management',
        },
        {
          text: 'Редактирование управляющей компании',
          disabled: true,
          href: '#',
        },
      ],
    };
  },
  created () {
    this.getManagementCompany(this.id)
      .then(() => {
        this.formDoorphone.name = this.managementCompany.name;
        this.formDoorphone.address = this.managementCompany.address;
        this.formDoorphone.contacts = this.managementCompany.contacts;
        this.formDoorphone.groupId = this.managementCompany.management_group.id;
      });
    this.getManagementsGroups({ pagination: 1 })
      .then((response) => {
        this.totalCompaniesGroup = response.meta.total;
      })
      .catch(() => {
        this.$flash_warning('Ошибка при загрузке групп управляющих компаний');
      });
  },
  computed: {
    ...mapGetters({
      managementCompany: 'ManagementCompany/managementCompany',
      managementsGroup: 'GroupManagementCompany/managementsGroup',
    }),
  },
  methods: {
    ...mapActions({
      getManagementCompany: 'ManagementCompany/getManagementCompany',
      getManagementsGroups: 'GroupManagementCompany/getManagementsGroups',
      updateManagementCompany: 'ManagementCompany/updateManagementCompany',
    }),
    save () {
      this.$refs.form.validate();
      this.$nextTick(() => {
        if (this.valid) {
          const dataManagementCompany = {
            name: this.formDoorphone.name,
            address: this.formDoorphone.address,
            contacts: this.formDoorphone.contacts,
            group_id: this.formDoorphone.groupId,
          };

          this.updateManagementCompany({
            id: this.$route.params.id,
            data: dataManagementCompany,
          })
            .then(() => {
              this.$router.push({ name: 'Management' });
              this.$flash_success('Изменения успешно сохранены');
            })
            .catch(() => {
              this.$flash_warning('Ошибка при редактировании управляющей компании');
            });
        }
      });
    },
    returnManagement () {
      this.$router.push({ name: 'Management' });
    },
  },
};
</script>
